var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outofservice"},[_c('div',{staticClass:"textAreaa"},[_vm._v(" 現在は利用できません ")]),_c('sub-btn',{on:{"click":function($event){return _vm.onHome()}}},[_vm._v("プリクラONのホームに戻る")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }